import BaseModel from '@/models/BaseModel';

/**
 * Crm Service base model
 */
export default class CrmServiceModel extends BaseModel {

  // Route configuration
  privateRoutes() {
    return {
      fetch: process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/{id}',
      save: process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '',
      update: process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/{id}',
      create: process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '',
      delete: process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/{id}',
      fetchConnection: process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/{id}/connection/{connection}',
      exists: process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/exists',
    }
  }

}
